import { ChevronsUp, ClipboardList, LayoutDashboard, LogOut, Ship, UserRound } from 'lucide-react'
import { RouteConstant } from '../routes/RouteConstant'
import { useSelector } from 'react-redux'
import { IconPennant2 } from '@tabler/icons-react'

const SuperAdminMenu = [
    {
      label: "Dashboard",
      url: RouteConstant.DASHBOARD,
      icon: <LayoutDashboard size="20" />
    },
    {
      label: "Users Management",
      url: RouteConstant.USERS,
      icon: <UserRound size="20" />
    },
    {
      label: "Vessels", 
      url: RouteConstant.VESSEL, 
      icon: <Ship size="20" />
    },
    {
      label: "Masters",
      expand: true,
      icon: <ChevronsUp size="20" />,
      more: [
        {label: "Chapter", url: RouteConstant.CHAPTER, icon: <ClipboardList size="16" />},
      ]
    },

    {
      label: "OCIMF",
      expand: true,
      icon: <IconPennant2 size="20" />,
      more: [
        {label: "Vessels", url: RouteConstant.OCIMFVESSEL, icon: <Ship size="20" />},
      ]
    },
    {
      label: "Logout",
      icon: <LogOut size="20" />
    }
]

const InspectorMenu = [
  {
    label: "Vessels", 
    url: RouteConstant.VESSEL, 
    icon: <Ship size="20" />
  },
  {
    label: "Logout",
    url: RouteConstant.DASHBOARD,
    icon: <LogOut size="20" />
  }
]

const ManagerMenu = [
  {
    label: "Users Management",
    url: RouteConstant.USERS,
    icon: <UserRound size="20" />
  },
  {
    label: "Vessels", 
    url: RouteConstant.VESSEL, 
    icon: <Ship size="20" />
  },
  {
    label: "Logout",
    url: RouteConstant.DASHBOARD,
    icon: <LogOut size="20" />
  }
]

const MenuItems = () => {

  const user = useSelector((state) => state.auth.user);

  const role = user?.role?.role

  if(role === "SADMIN"){
    return SuperAdminMenu
  }else if(role === "INSPECTOR"){
    return InspectorMenu
  }else if(role === "MANAGER"){
    return ManagerMenu
  }

  return []

}

export default MenuItems